<template>
  <v-simple-table class="rounded-lg simple-table elevation-1" dense
    :class="!$slots['action-bar'] ? 'simple-table--round-top' : ''">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" v-for="(header, index) in headers" :key="index">
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td v-for="(header, index) in headers" :key="index">
             <template v-if="header.type && header.type == 'html'">
              <p><span v-html="item[header.value]"></span></p>
            </template>
            <!-- Columna "actions" con los botones de acciones-->
            <template v-else-if="header.value == 'actions'">
              <v-tooltip top v-for="actionBtn in actionBtnList" :key="actionBtn.action">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    v-if="actionBtn.is_svg"
                    @click="clickColActionBtn(actionBtn.action, item)"
                    icon 
                    v-bind="attrs"
                    v-on="on"
                  >
                    <img
                      v-if="actionBtn.is_svg"
                      :src="require(`@/assets/${actionBtn.icon}`)"
                      @click="clickColActionBtn(actionBtn.action, item)"
                    />
                  </v-btn>
                  <v-btn v-else @click="clickColActionBtn(actionBtn.action, item)" color="primary" icon v-bind="attrs"
                    v-on="on">
                    <v-icon>{{ actionBtn.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ actionBtn.name }}</span>
              </v-tooltip>
            </template>
            <template v-else-if="header.type && header.type == 'link' && header.link_text">
              <p v-if="item[header.value]"><a :href="item[header.value]">{{ header.link_text }}</a></p>
            </template>
            <template v-else-if="header.type && header.type == 'blob_link' && header.link_text">
              <p v-if="item[header.value]"><a @click="clicked_link(item)">{{ header.link_text }}</a></p>
            </template>
            <template v-else-if="header.type && header.type == 'nested_property'">
              <span>
                {{ getSplitedItem(item, header.value) }}
              </span>
            </template>
            <template v-else-if="header.type && header.type == 'nested_property_link'">
              <a :href="getSplitedItem(item, header.value)" v-if="getSplitedItem(item, header.value)">
                {{ header.link_text }}
              </a>
            </template>
            <template v-else-if="header.type && header.type == 'nested_property_link'">
              <a :href="getSplitedItem(item, header.value)">
              {{ header.link_text }}
              </a>
            </template>
            <template v-else>
              {{ item[header.value] }}
            </template>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { client } from "@/api/client"


export default {

  name: 'AppSimpleTableWithApi2',
  props: {
    headers: {
      type: Array,
      default: [],
    },
    url: {
      type: String,
      required: true
    },
    actionBtnList: {
      type: Array,
      default() {
        return [];
      }
    },
    api_params: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      items: [],
    }
  },
  methods: {
    getItems() {
      return new Promise((resolve, reject) => {
        this.loadingItems = true;
        let params = {};
        for (let key in this.api_params) {
          params[key] = this.api_params[key];
        }
        client.get(this.url, { params: params }).then(response => {
          this.items = response.data.results;
          this.$emit('has-items', this.items.length > 0);
          this.$emit('get-items', this.items);
          resolve()
        }).catch(error => {
          this.$emit('has-items', false);
          reject(error);
        });
      });
    },
    clickColActionBtn(action, item) {
      this.$emit('click-col-action-btn', action, item);
    },
    async clicked_link(item) {
      let s_url = item['path']
      const response = await fetch(s_url)
      const blob = await response.blob();
      const url = await URL.createObjectURL(blob)
      const a = document.createElement("a");
      a.href = url;
      let ext = 'eml'
      a.download = 'correo.' + ext;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    },
    getSplitedItem(item, header) {
      // [campo 1, campo 2] ...
      const parts = header.split('.');
      let current = item;
      for (const part of parts) {
        if (current[part] === undefined) {
          return undefined; // Return undefined if the path does not exist
        }
        current = current[part];
      }
      return current;
    },
  },
  mounted() {
    this.getItems();
  },
}
</script>

<style scoped>
.simple-table {
  background-color: #DEDCFF !important;
}

::v-deep.simple-table thead>tr:not(.simple-table__action-bar)>th {
  background-color: #EBEAFF !important;
  border-radius: 0 !important;
  color: #66359B !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:first-of-type {
  border-radius: 0.5rem 0 0 0 !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:last-of-type {
  border-radius: 0 0.5rem 0 0 !important;
}

::v-deep.simple-table tbody>tr>td {
  background-color: #FFF !important;
}

::v-deep.simple-table tbody>tr>td:not(:last-of-type) {
  border-right: 1px solid #66359B;
}
</style>